<template>
<div>
 <span class='color-melody title tamanhotitle'>{{$t('games.melody.line')}}</span>
 <div class="editmelody tamanhoicon" @click="$emit('back')">
            <img :src="require('@/assets/buttons/newbuttons/melody/back.svg')" />
        </div>
<div class="curve-container">
    <div class="curve-selector">
        <div v-for="(value, name) in balls" :key="name" :class="'grid-balls' + ' '  + name">
            <div v-for="(value2, name2) in value" :key="name2" :class="'col' + ' '  + name2">
                <div v-for="(color, name3) in value2" :key="name3" :id="name3" class="ball" @mouseover="select_ball(name, name2, name3)">
                    <img :src='require("@/assets/buttons/" + color + "-ellipse-curve.svg")'>
                </div>
            </div>
        </div>
    </div>
    <canvas id="canvas"></canvas>
</div>
</div>
</template>

<script>
export default {
    name: "CurveSelector",
    emits: ['curveDrawn','back'],
    created() {
        for (let i = 1; i <= this.n_phrases; i++) {
            this.balls['grid-balls-' + i] = {};
            this.selected['grid-balls-' + i] = {};

            for (let j = 1; j <= 8; j++) {

                let balls_names = [
                    'ball-' + i + '-' + j + '-1',
                    'ball-' + i + '-' + j + '-2',
                    'ball-' + i + '-' + j + '-3'
                ];

                this.balls['grid-balls-' + i]['col-' + j] = {};
                for (const name in balls_names) {
                  this.balls['grid-balls-' + i]['col-' + j][balls_names[name]] = 'orange';
                }
                this.selected['grid-balls-' + i]['col-' + j] = 'ball-' + i + '-' + j + '-2';
                this.balls['grid-balls-' + i]['col-' + j]['ball-' + i + '-' + j + '-2'] = 'red';
            }
        }
    },
    mounted() {
      this.draw_curve();
    },
    data() {
        return {
            balls: {},
            selected: {},
            positions: [],
            n_phrases: 3,
        };
    },
    methods: {
        select_ball(grid, col, row) {
            // SELECT A SINGLE BALL PER COL
            if (this.selected[grid][col] != '') {
                this.balls[grid][col][this.selected[grid][col]] = 'orange'
            }
            this.selected[grid][col] = row;
            this.balls[grid][col][row] = 'red';

            this.draw_curve();
            this.$emit('curveDrawn', this.curve_points());
        },
        curve_points() {
            let selected_points = [];
            if (this.selected['grid-balls-1']['col-1'] == '') {
                this.selected['grid-balls-1']['col-1'] = 'ball-1-1-2';
            }
            for (const key in this.selected) {
                for (const inner in this.selected[key]) {
                    if (this.selected[key][inner] != '') {
                        selected_points.push(this.selected[key][inner]);
                    } else {
                        let last_point = selected_points[selected_points.length - 1];
                        let last_row = last_point.charAt(last_point.length - 1);
                        let grid = key.charAt(key.length - 1);
                        let col = inner.charAt(inner.length - 1);
                        selected_points.push('ball-' + grid + '-' + col + '-' + last_row);
                    }

                }
            }
            selected_points.sort();
            return selected_points;
        },
        point_positions(points) {

            var cv = document.getElementById('canvas');
            var cv_rect = cv.getBoundingClientRect();

            cv.width = cv_rect.width;
            cv.height = cv_rect.height;

            this.positions = [];

            this.positions.push({
                x: 0,
                y: cv_rect.height / 2.0
            });

            points.forEach((point) => {
                var p = document.querySelector('#' + point);
                var rect = p.getBoundingClientRect();

                let img_w = rect.width / 2.0;
                let img_h = rect.height / 2.0;

                let x = rect.left + img_w;
                let y = rect.top + img_h;

                let coord = {
                    x: Math.abs(x - cv_rect.x),
                    y: Math.abs(y - cv_rect.y),
                };

                this.positions.push(coord);
            });

            this.positions.push({
                x: cv_rect.width,
                y: cv_rect.height / 2.0
            });

            return this.positions;
        },
        draw_curve() {
            let sel_curve_points = this.curve_points();
            let sel_point_pos = this.point_positions(sel_curve_points);

            var canvas = document.getElementById('canvas');
            var ctx = canvas.getContext('2d');

            this.draw_curve_aux(ctx, sel_point_pos, 0.5, 'black', 2);
        },
    },

};
</script>

<style>
.curve-container {
position: absolute;
    left: 0;
    top: 21%;
    width: 76%;
    height: 71%;
    margin: 0% 12%;
    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    border-radius: 30px;
    animation: movecontainerCurveSelector 0.5s ease-in-out;
}
@keyframes movecontainerCurveSelector {
  0% {top:40%;}
  100% {top:15%;}
}

.curve-selector {
    position: absolute;
    top: 12%;

    height: 80%;
    width: 100%;

    display: flex;
    justify-content: space-between;
}

.line {
    border: 3px solid rgba(238, 188, 137, 0.3);
    height: 96%;
}

.clean {
    position: absolute;
    top: 0.65rem;
    right: 0.65rem;
}
.clean > img {
    width: 100%;
}

.grid-balls {
    width: 80%;
    padding-left: 5%;
    padding-right: 5%;

    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;

    display: flex;
    justify-content: space-between;
}

.grid-balls+.grid-balls {
    border-left: 3px solid #3FA535;
}

.col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 80%;
    margin-top: 15%;
}


/* .col-1,
.col-3,
.col-5 {
    margin-top: 20%;
}

.col-2,
.col-4,
.col-6 {
    margin-bottom: 25%;
} */

.ball {
    height: width;
    padding: 0px;
    margin: 0px;
}

.ball>img {
    width: 0.75rem;
}

#canvas {
    width: 100%;
    height: 100%;
}


@media only screen and (max-width: 480px) {
  .clean{
    width:2rem;
  }
  .ball>img{
    width:0.2rem;
  }
}
@media only screen and (min-width: 480px) and (max-width: 550px) {
  .clean{
    width:2.2rem;
  }
  .ball>img{
    width:0.3rem;
  }
}
@media only screen and (min-width: 550px) and (max-width: 630px){
  .clean{
    width:2.4rem;
  }
  .ball>img{
    width:0.4rem;
  }
}
@media only screen and (min-width: 630px) and (max-width: 718px){
  .clean{
    width:2.6rem;
  }
  .ball>img{
    width:0.5rem;
  }
}
@media only screen and (min-width: 718px) and (max-width: 806px) {
  .clean{
    width:2.8rem;
  }
  .ball>img{
    width:0.6rem;
  }
}
@media only screen and (min-width: 806px) and (max-width: 1024px) {

  .clean{
    width:3rem;
  }
  .ball>img{
    width:0.7rem;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1200px) {
  .clean{
    width:3.2rem;
  }
  .ball>img{
    width:0.8rem;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1366px) {
  .clean{
    width:3.4rem;
  }
  .ball>img{
    width:0.9rem;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1540px){
  .clean{
    width:4rem;
  }
  .ball>img{
    width:1rem;
  }
}
@media only screen and (min-width: 1540px) and (max-width: 1680px){
  .clean{
    width:4.4rem;
  }
  .ball>img{
    width:1.1rem;
  }
}
@media only screen and (min-width: 1680px) and (max-width:2350px){
  .clean{
    width:4.8rem;
  }
  .ball>img{
    width:1.2rem;
  }
}
@media only screen and (min-width: 2350px) {
  .clean{
    width:5.4rem;
  }
  .ball>img{
    width:1.6rem;
  }
}
</style>
